"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _Item = _interopRequireDefault(require("../Menu/Item"));

var _default = _Item.default;
exports.default = _default;